import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import type { CatCrane } from "../models/CatCrane";

export const getCranes = async () => {
  const apiService = new MESApiService();

  return await apiService.callV2("[BYI].[GetCatCranes]", []);
};

export const upsertCrane = async (crane: CatCrane) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [
    { name: "CraneId", value: crane.CraneId },
    { name: "Name", value: crane.Name },
    { name: "IsActive", value: crane.IsActive },
  ];

  return await apiService.callV2("[BYI].[UpsertCatCrane]", parameters);
};

export const deleteCrane = async (craneId: number) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [{ name: "CraneId", value: craneId }];

  return await apiService.callV2("[BYI].[DeleteCatCrane]", parameters);
};
